import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getBalanceOfTokens } from "../../services/wallet.service";
import RpcProviderManager from "../../utils/jsonRpcProvider";
import { RootState } from "../store";

export type WalletDataType = {
  [key: string]: string;
};

interface walletState {
  balances: WalletDataType;
  loading: boolean;
}

const initialState: walletState = {
  balances: {
    usdc: "0",
    soil: "0",
  },
  loading: false,
};

interface GetBalancesPayload {
  address: string;
  chainId: number;
}

export const getBalances = createAsyncThunk(
  "wallet/getBalances",
  async ({ address, chainId }: GetBalancesPayload, thunkApi) => {
    const state = thunkApi.getState() as RootState;
    const contracts =
      state.settings.supportedChains.find(
        (c) => c.chainId === chainId.toString()
      )?.tokens ?? [];
    const tokens = contracts
      .map((c) => ({
        address: c.address,
        symbol: c.token.toLowerCase(),
      }))
      .filter((t) => t !== null) as { address: string; symbol: string }[];

    const provider = RpcProviderManager.getInstance().getProvider(chainId);
    return getBalanceOfTokens(address, tokens, provider);
  }
);

const resetWalletBalance = createAction("wallet/resetWalletData");

export const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBalances.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBalances.rejected, (state) => {
      state.loading = false;
      state.balances = initialState.balances;
    });
    builder.addCase(getBalances.fulfilled, (state, { payload }) => {
      if (Object.values(payload).length > 0) {
        state.loading = false;
        state.balances = { ...payload };
      }
    });
    builder.addCase(resetWalletBalance, (state) => {
      state.balances = {
        usdc: "0",
        soil: "0",
      };
    });
  },
});

export const wallet = { getBalances, resetWalletBalance };

export default walletSlice.reducer;
